module.exports = __webpack_public_path__ + "img/wallpaper-limit-co2-in-the-menu.172e217a.png";